import { CanvasDrawImageSource } from "models-webgl2";

export const resizeImage = (
  source: CanvasDrawImageSource,
  newWidth: number,
  newHeight: number,
  disableMirror = false,
): HTMLCanvasElement => {
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(Math.abs(newWidth), 0);
  canvas.height = Math.max(Math.abs(newHeight), 0);

  const context = canvas.getContext("2d");

  if (!context || !canvas.width || !canvas.height) return canvas;

  context.save();
  !disableMirror && context.scale(Math.sign(newWidth), Math.sign(newHeight));
  context.drawImage(source, 0, 0, newWidth, newHeight);
  context.restore();

  return canvas;
};
